/** @format */
import TextField from '@mui/material/TextField';
import { toString } from 'lodash';
import React from 'react';
import { IMaskInput } from 'react-imask';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, numberType, ...other } = props;

  let option = {
    mask: Number,
    definitions: {
      '#': /[1-9]/
    }
  };

  if (numberType === 'hex') {
    option = {
      mask: /^[A-Fa-f0-9]+$/,
      prepareChar: (str) => str.toUpperCase(),
      maxLength: 256
    };
  }
  return (
    <IMaskInput
      {...other}
      {...option}
      inputRef={ref}
      onAccept={(value, _maskRef, e) => {
        if (e) {
          // let val = isUnformat ? unformatValue(value) : value;
          // console.log('unformatValue',value,val);
          onChange({ target: { name: props.name, value } });
        }
      }}
      overwrite
    />
  );
});

// eslint-disable-next-line react/display-name
const NumberField = React.forwardRef(({ InputProps, value, ...props }, ref) => {
  return (
    <TextField
      ref={ref}
      {...(value && { value: toString(value) })}
      InputProps={{
        inputComponent: TextMaskCustom,
        ...InputProps
      }}
      // size="small"
      {...props}
    ></TextField>
  );
});

export default NumberField;
